import Vue from 'vue';
import VueStripeCheckout from 'vue-stripe-checkout';
import environment from '@/environment';

Vue.use(VueStripeCheckout, environment.publish_key_stripe);
